jQuery.fn.extend(
{
  readonly: function ()
  {
      jQuery(this).setreadability(PIE.readonly.disable);   
  },
  readwrite: function ()
  {
      jQuery(this).setreadability(PIE.readonly.enable);
  },
  setreadability: function(callback)
  {
    var selector = 'input:not([type="hidden"], [type="button"], [type="submit"], .always, .alwaysEnable), select:not(.always, .alwaysEnable), textarea:not(.always, .alwaysEnable)';
    var $element = jQuery(this);

    if ($element.is(selector))
      callback($element);
    else
      $element.find(selector).each(function (i, c) 
      { 
        callback(c); 
      }); 
  }
});